<template>
  <div class="notice-sys">
    <div class="part-title">
      <span class="txt">{{ $t('home.systemAnnouncement') }}</span>
      <!-- <span class="seeall" @click="openAnnounceMange">
        {{ $t('home.viewAll') }}<i class="icon iconfont icon-you-line"></i>
      </span> -->
    </div>
    <div class="part-content">
      <div class="part-content-list scroll-bar-y">
        <template v-if="NoticeList.length > 0">
          <div
            class="part-content-item"
            v-for="item in NoticeList"
            :key="item.id"
          >
            <!-- <div class="left"><span class="red-point"></span></div> -->
            <div class="content ellipsis-inline" @click="viewNotice(item)">
              <span :title="item.anns_title">{{ item.anns_title }}</span>
            </div>
            <div class="right">{{ item.updated_at.substr(0, 10) }}</div>
          </div>
        </template>
        <template v-else>
          <Empty />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { getTopNotice } from "@/api/index";
export default {
  name: "notice-sys",
  data() {
    return {
      NoticeList: [],
    };
  },
  mounted() {
    this.getHomeNotice();
  },
  methods: {
    ...mapActions(["changeDrawerInfo", "addTab"]),
    openAnnounceMange() {
      const { my: { ektv3_page = "//ektv3-test.icsoc.net" } = {} } =
        this._config.URL || {};
      let tabItem = {
        key: this.$t('home.announcementManage'),
        name: this.$t('home.announcementManage'),
        url: `${ektv3_page}/ekt/announce`,
      };
      this.addTab(tabItem);
    },
    viewNotice(notice) {
      const {
        my: { ektv3_page },
      } = this._config.URL;
      this.changeDrawerInfo({
        title: this.$t('home.announcementDetail'),
        drawerShow: true,
        drawerSrc: `${ektv3_page}/ekt/announce/details/${notice.id}`,
        drawerWidth: 600,
      });
    },
    getHomeNotice() {
      getTopNotice({ flag: 1 })
        .then((res) => {
          const { code = 0, data = [], message } = res;
          if (code == 0) {
            this.NoticeList = data;
          } else {
            console.log("查询置顶通知异常", code, message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.notice-sys {
  padding: 0 16px 16px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .part-title {
    line-height: 48px;

    .txt {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #323233;
      text-align: left;
    }

    .seeall {
      float: right;
      font-weight: 400;
      font-size: 12px;
      color: #969799;
      cursor: pointer;

      .iconfont {
        font-size: 14px;
      }
    }
  }

  .part-content {
    flex: 1 1 0;
    overflow: hidden;
    padding-bottom: 10px;

    .part-content-list {
      .part-content-item {
        width: 100%;
        display: flex;
        font-size: 12px;
        line-height: 32px;

        .left {
          width: 16px;

          .red-point {
            display: inline-block;
            height: 8px;
            width: 8px;
            border-radius: 100%;
            background-color: #ff4d4f;
          }
        }

        .content {
          flex: 1;
          cursor: pointer;
        }

        .right {
          width: 92px;
          text-align: right;
          color: #969799;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/homeTab/noticeSys/index.vue